// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_2n9f3z7FlN8YCqQxs2SSH0"};